var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.getClass,attrs:{"color":_vm.color,"type":_vm.type,"disabled":_vm.disabled,"elevation":"0"}},[_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }